// @ts-nocheck

import { createSelector } from 'reselect';

import { selectBetslipOptions } from '../../modules/betslip-options/selectors/betslipOptionsPrimary.selector';
import { selectEntitiesBetslipIds } from '../../selectors/entities/betslipIds/entitiesBetslipIdsPrimary.selector';
import {
  selectHistoryFilter,
  selectHistoryLimit,
  selectHistoryLoading,
  selectHistoryOffset,
} from '../../selectors/history/historyPrimary.selector';
import { selectPreviouspagesEntity } from '../../selectors/previouspages/previouspagesPrimary.selector';
import { selectUserConnected } from '../../selectors/user/userPrimary.selector';
import { BetslipFilters } from '../../types/history';

const selectCurrentPage = createSelector([selectHistoryOffset, selectHistoryLimit], (offset, limit) => offset / limit);

const selectCachedBetslipIds = createSelector(
  [selectBetslipOptions, selectHistoryFilter],
  (betslipOptions, historyFilter) => {
    if (historyFilter === BetslipFilters.FAVORITES) {
      return Object.keys(betslipOptions).filter((betslipId) => !betslipOptions[betslipId].isFavorite);
    }

    if (historyFilter === BetslipFilters.HIDDEN) {
      return Object.keys(betslipOptions).filter((betslipId) => !betslipOptions[betslipId].isHidden);
    }

    return Object.keys(betslipOptions).filter((betslipId) => betslipOptions[betslipId].isHidden);
  },
);

const selectBetslipIds = createSelector(
  [selectEntitiesBetslipIds, selectCachedBetslipIds],
  (betslipIds, cachedBetslipIds) => {
    return !cachedBetslipIds.length
      ? betslipIds
      : betslipIds.filter((betslipId) => cachedBetslipIds.indexOf(betslipId.toString()) === -1);
  },
);

const selectHistoryProps = createSelector(
  [
    selectUserConnected,
    selectBetslipIds,
    selectHistoryLoading,
    selectCurrentPage,
    selectPreviouspagesEntity,
    selectHistoryFilter,
  ],
  (connected, betslipIds, loading, currentPage, previousPosition, historyFilter) => ({
    connected,
    betslipIds,
    loading,
    currentPage,
    previousPosition,
    filter: historyFilter,
  }),
);

export default selectHistoryProps;
